// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import * as variables from './_localhost';

const env = variables.default;

export const environment = {
  production: false,
  environment: 'localhost',
  AUTHAPI_BASE_URL: 'https://hubapi.homecaptain.com/dev/auth',
  HUBAPI_BASE_URL: 'https://hubapi.homecaptain.com/dev',
  HS_BASE_API_URL: 'https://cpvjaitd0m.execute-api.us-west-2.amazonaws.com',
  HS_SEARCH_URL: 'https://homecaptain.hsp-fesandbox.homestoryrewards.com',
  HS_LANDING_URL: 'https://homecaptain.hsp-fesandbox.homestoryrewards.com/partner-landing',
  DOMAIN: 'localhost',
  ...env,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
